<template lang="pug">
  el-amap(
    class="amap-demo"
    v-loading="isLoading"
    vid="amap"
    :zoom="zoom"
    :center="center")
    el-amap-polyline(
      :editable="polyline.editable"
      :path="polyline.path"
      :events="polyline.events")
</template>
<script>
  import { fetchList } from '@/utils/api'
  import { expire } from '@/utils/auth'

  export default {
    props: {
      resource: {
        type: String
      }
    },
    created () {
      let result = expire()
      if (!result) {
        this.$router.push('/login')
      }
      this.getData()
    },
    data () {
      return {
        isLoading: false,
        zoom: 12,
        center: [121.5273285, 31.25515044],
        polyline: {
          path: [],
          events: {
            click (e) {
              console.log('click polyline')
            },
            end: (e) => {
              let newPath = e.target.getPath().map(point => [point.lng, point.lat])
              console.log(newPath)
            }
          },
          editable: false
        }
      }
    },
    methods: {
      changeEditable () {
        this.polyline.editable = !this.polyline.editable
      },
      getData () {
        this.isLoading = true
        fetchList({
          resource: this.resource,
          orderBy: '',
          filterBy: '',
          pageSize: 999999,
          pageIndex: 1
        })
        .then(data => {
          let pathList = []
          this.polyline.path = data.data.map(item => {
            pathList.push([item.longitude, item.latitude])
          })
          this.polyline.path = pathList.filter(path => path[0] && path[1])
          this.center = this.polyline.path.length ? this.polyline.path[0] : this.center
          console.log(this.polyline.path)
          this.isLoading = false
        })
      }
    }
  }
</script>

<style scoped lang="sass">
  .amap-demo
    height: 450px
</style>



// WEBPACK FOOTER //
// TrackMap.vue?27b481ee